// extracted by css-extract-rspack-plugin
var _1 = "VBzYrOKr9VIcoRrG";
export { _1 as "badge" }
// extracted by css-extract-rspack-plugin
var _1 = "VBzYrOKr9VIcoRrG";
export { _1 as "badge" }
